import useMediaQuery from '@mui/material/useMediaQuery';

export default function PrefersDarkMode() {
  return useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
}
